export default "__VITE_ASSET__DkHmjZu___"